import DataTableRow_default from "../../../components/data-table/DataTableRow.vue.js";
import RequestAuthDataTableInput_default from "./RequestAuthDataTableInput.vue.js";
import { fetchOAuth2Metadata } from "../helpers/fetch-oauth2-metadata.js";
import { oauth2MetadataToFlows } from "../helpers/oauth2-metadata-to-flows.js";
import { Fragment, createBlock, createCommentVNode, createElementBlock, createElementVNode, createTextVNode, createVNode, defineComponent, openBlock, unref, withCtx } from "vue";
import { ScalarButton } from "@scalar/components/button";
import { useToasts } from "@scalar/use-toasts";
import { useLoadingState } from "@scalar/components/loading";
//#region src/v2/blocks/scalar-auth-selector-block/components/OAuth2Metadata.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = { class: "flex h-8 w-full items-center justify-end border-t" };
var OAuth2Metadata_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "OAuth2Metadata",
	props: {
		scheme: {},
		name: {},
		environment: {},
		eventBus: {},
		proxyUrl: {},
		customFetch: {}
	},
	setup(__props) {
		const loader = useLoadingState();
		const { toast } = useToasts();
		const updateMetadataUrl = (oauth2MetadataUrl) => __props.eventBus.emit("auth:update:security-scheme", {
			name: __props.name,
			payload: {
				type: "oauth2",
				oauth2MetadataUrl
			}
		});
		/** Apply metadata only to the scheme and URL that initiated the request. */
		const fetchConfiguration = async () => {
			const url = __props.scheme.oauth2MetadataUrl;
			const schemeName = __props.name;
			if (!url || loader.isLoading) return;
			loader.start();
			const [error, metadata] = await fetchOAuth2Metadata(url, __props.proxyUrl, __props.customFetch);
			await loader.clear();
			if (__props.name !== schemeName || __props.scheme.oauth2MetadataUrl !== url) return;
			if (error) {
				toast(error.message, "error");
				return;
			}
			__props.eventBus.emit("auth:update:security-scheme", {
				name: __props.name,
				payload: {
					type: "oauth2",
					flows: oauth2MetadataToFlows(metadata, __props.scheme.flows)
				}
			});
		};
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [createVNode(unref(DataTableRow_default), null, {
				default: withCtx(() => [createVNode(RequestAuthDataTableInput_default, {
					environment: __props.environment,
					modelValue: __props.scheme.oauth2MetadataUrl ?? "",
					placeholder: "https://example.com/.well-known/oauth-authorization-server",
					"onUpdate:modelValue": updateMetadataUrl
				}, {
					default: withCtx(() => [..._cache[0] || (_cache[0] = [createTextVNode(" Metadata URL ", -1)])]),
					_: 1
				}, 8, ["environment", "modelValue"])]),
				_: 1
			}), __props.scheme.oauth2MetadataUrl ? (openBlock(), createBlock(unref(DataTableRow_default), {
				key: 0,
				class: "min-w-full"
			}, {
				default: withCtx(() => [createElementVNode("div", _hoisted_1, [createVNode(unref(ScalarButton), {
					class: "mr-0.75 p-0 px-2 py-0.5",
					loader: unref(loader),
					size: "sm",
					variant: "outlined",
					onClick: fetchConfiguration
				}, {
					default: withCtx(() => [..._cache[1] || (_cache[1] = [createTextVNode(" Fetch Configuration ", -1)])]),
					_: 1
				}, 8, ["loader"])])]),
				_: 1
			})) : createCommentVNode("", true)], 64);
		};
	}
});
//#endregion
export { OAuth2Metadata_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=OAuth2Metadata.vue_vue_type_script_setup_true_lang.js.map